import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { usePatientSurgeryStore } from "../hooks";
import { Error404 } from "../components";
import { QuizCard } from "../components/cards";
import { FlowContainer } from "../components/utils";
import { Loading as LoadingPatientSurgery } from "../ui";

export const QuizPage = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,

    // Methods
    startDecryptKey,
  } = usePatientSurgeryStore();

  const { state = null } = patientSurgery.data || {};
  const { isLoading, message } = patientSurgery;

  const [searchParams] = useSearchParams();
  const key = searchParams.get("key");
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    startDecryptKey(key ?? "");
  }, [key]);

  if (!key || (!isLoading && message?.type === "error-patientSurgery")) {
    return <Error404 />;
  }

  return isLoading ? (
    <LoadingPatientSurgery />
  ) : (
    <div className="bg-light" style={{ minHeight: "100vh" }}>
      {state === "QUIZ_SEND" ? <QuizCard /> : <FlowContainer />}
    </div>
  );
};
